import React from 'react';
import ReactDOM from 'react-dom/client';
import GreaseLubrication from './GreaseLubrication';

const $root: HTMLElement | null = document.getElementById(
	'timken-tool-grease-lubrication',
);

if ( $root ) {
	ReactDOM.createRoot( $root ).render(
		<React.StrictMode>
			<GreaseLubrication />
		</React.StrictMode>
	);
}
